<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ $timeZoneDateFormat(weeklyReport.starts_at, 'LL') }} -
        {{ $timeZoneDateFormat(weeklyReport.ends_at, 'LL') }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="weeklyReport" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "cash-register-view-logs",

  components: { LogListTable },

  props: ["weeklyReport"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
